import gql from "graphql-tag"

export default gql`
  {
    currentUser {
      avatarUrl
      company {
        name
      }
      email
      fullName
      id
      position
      trackingData
    }
  }
`
